import { render, staticRenderFns } from "./CardProject2.vue?vue&type=template&id=2c27f5ce&"
import script from "./CardProject2.vue?vue&type=script&lang=js&"
export * from "./CardProject2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports